import { graphql } from 'react-relay/legacy';

export const catalogRootQuery = graphql`
    query catalogRootQuery(
        $pageTypeId: String = ""
        $rootId: String = ""
        $showModules: Boolean = true
        $hasUserId: Boolean = false
        $userId: String = ""
    ) {
        viewer {
            catalogPage(id: $rootId, pageTypeId: $pageTypeId) {
                title
                socialShareURLWithFallback
            }
            ...CatalogLayout_viewer
        }
    }
`;
